import { Middleware } from "redux";
import { AppState } from "../redux/AppTypes";
import {
  DoFetchJiraAction,
  DO_FETCH_JIRA,
  FAIL_JIRA,
  FetchJiraAction,
  FETCH_JIRA,
  LoadJiraAction,
  LOAD_JIRA,
} from "./JiraTypes";
import service from "./JiraService";
import { shouldFetch } from "../redux/LoadStatus";

const fetchJiraMiddleware: Middleware<{}, AppState> = (store) => (
  next
) => async (action: FetchJiraAction) => {
  next(action);
  if (action.type === FETCH_JIRA) {
    if (shouldFetch(store.getState().jira.status, action.force)) {
      store.dispatch({ type: DO_FETCH_JIRA });
    }
  }
};

const doFetchJiraMiddleware: Middleware<{}, AppState> = (store) => (
  next
) => async (action: DoFetchJiraAction) => {
  next(action);
  if (action.type === DO_FETCH_JIRA) {
    try {
      const [projects, projectCategories] = await Promise.all([
        service.fetchProjects(),
        service.fetchProjectCategories(),
      ]);
      const action: LoadJiraAction = {
        type: LOAD_JIRA,
        projects,
        projectCategories,
      };
      store.dispatch(action);
    } catch (error) {
      store.dispatch({
        type: FAIL_JIRA,
        error,
      });
    }
  }
};

const middlewares = [fetchJiraMiddleware, doFetchJiraMiddleware];
export default middlewares;
